import { render, staticRenderFns } from "./MarinaMismoV22025.vue?vue&type=template&id=62463d9d&scoped=true"
import script from "./MarinaMismoV22025.vue?vue&type=script&lang=js"
export * from "./MarinaMismoV22025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62463d9d",
  null
  
)

export default component.exports